import MediaWindowService from './media-window';

class Services {
    constructor() {
        this.mediaWindow = new MediaWindowService();
    }

}

export default Services;